export interface SearchTermHistoryModel {
  id:          string;
  search_term: string;
  hit:         number;
  entity_type: string;
  user_id:     number;
}

export enum SearchTermHistoryEntryTypeEnum {
  STRING            = 'string',
  WORKING_PERIOD    = 'working_period',
  VACATION_REQUEST  = 'vacation_request',
  COMPANY           = 'company',
  PHOTO_DOCUMENT    = 'photo_document',
  EBS               = 'ebs',
  INVOICE           = 'invoice',
  ASSIGNMENTS       = 'assignments',
  MILEAGE_MONEY     = 'mileage_money',
  REFERRALS         = 'referrals',
  CONTRACT_EXT      = 'contract_ext',
  EXTERNAL_EMPLOYEE = 'external_employee',
}
